import { Link, Tooltip } from '@lego/klik-ui';
import { Link as ReactRouterLink } from 'react-router-dom';
import { useWorkspace } from '@/hooks/workspace';
import { paths } from '@/utility/global_paths';

type Props = {
  workspaceId: number;
  isText?: boolean;
};

export const WorkspaceTextLink = ({ workspaceId, isText = false }: Props) => {
  const { data, isLoading } = useWorkspace(isText ? null : workspaceId);

  if (isLoading || isText) {
    return <>{workspaceId}</>;
  }

  return (
    <Tooltip key={workspaceId} label={`Workspace ID: ${workspaceId}`}>
      <Link as={ReactRouterLink} p={0} to={paths.workspaceById(workspaceId)}>
        {data?.name || workspaceId}
      </Link>
    </Tooltip>
  );
};
